// extracted by mini-css-extract-plugin
module.exports = {"root":"root___3uI7M","icon":"icon___cundJ"};